import posthog from 'posthog-js'

import GlobalToast from '~/components/toasts/GlobalToast.vue'

export default function () {
  const getApi = async (url, showToast = true) => {
    const user = useUserStore()
    const nuxtApp = useNuxtApp()
    try {
      const response = await nuxtApp.$mainApi.get(url)
      return response.data
    } catch (error) {
      showToast
        ? useNuxtApp().$toast(
            () =>
              h(GlobalToast, {
                message: error?.response?.data.message,
                type: 'error',
                isGlobal: true,
              }),
            {
              type: 'error',
              icon: true,
              position: 'top-right',
              style: {
                top: user.isFullScreen ? '60px' : '0px',
              },
            },
          )
        : false

      if (showToast && !error.response) {
        // useNuxtApp().$toast.error('an error occurred!')
        useNuxtApp().$toast(
          () =>
            h(GlobalToast, {
              message: 'an error occurred!',
              type: 'error',
              isGlobal: true,
            }),
          {
            type: 'error',
            icon: true,
            position: 'top-right',
            style: {
              top: user.isFullScreen ? '60px' : '0px',
            },
          },
        )
      }
    }
  }

  const postApi = async (url, body = null, toast, useAuthApi = false) => {
    const nuxtApp = useNuxtApp()
    const user = useUserStore()
    try {
      const response = await nuxtApp.$mainApi.post(url, body)
      toast &&
        useNuxtApp().$toast(
          () =>
            h(GlobalToast, {
              message: 'success',
              type: 'success',
              isGlobal: true,
            }),
          {
            type: 'success',
            icon: true,
            position: 'top-right',
            style: {
              top: user.isFullScreen ? '60px' : '0px',
            },
          },
        )
      return response.data
    } catch (error) {
      // toast && useNuxtApp().$toast.error(error.response.data.message)
      toast &&
        useNuxtApp().$toast(
          () =>
            h(GlobalToast, {
              message: error.response.data.message,
              type: 'error',
              isGlobal: true,
            }),
          {
            type: 'error',
            icon: true,
            position: 'top-right',
            style: {
              top: user.isFullScreen ? '60px' : '0px',
            },
          },
        )
    }
  }

  const auth = async (useAuthApi = false) => {
    const user = useUserStore()
    if (user.playdeck) {
      window.parent.postMessage({ playdeck: { method: 'getUserProfile' } }, '*')
      const profile = await waitForMessage({
        origin: (o) => o === o, // tighten if you can
        match: (ev) => {
          console.log('match', ev)
          const d = ev.data
          if (d && d.playdeck?.method === 'getUserProfile' && d.playdeck?.value)
            return d.playdeck?.value
          return false
        },
        timeoutMs: 8000,
      })

      const body = {
        pdToken: profile.token,
        telegramUsername: profile.username,
        telegramFirstName: profile.firstName,
        telegramLastName: profile.lastName,
        telegramId: String(profile.telegramId),
        telegramLanguage: profile.locale,
        telegramPhotoUrl: profile.avatar,
        isInvited: true,
      }

      return postApi('/auth/play-deck', body, false, useAuthApi)
    } else {
      const RuntimeConfig = useRuntimeConfig()

      function isJsonString(str) {
        try {
          JSON.parse(str)
        } catch (e) {
          return false
        }
        return true
      }

      const initData = window.Telegram?.WebApp?.initData

      let userObjectString = ''

      if (initData !== 'user' && initData !== undefined) {
        const decodedQuery = decodeURIComponent(initData)

        const params = decodedQuery.split('&')

        params.forEach((param) => {
          const [key, value] = param.split('=')

          if (key === 'user') userObjectString = value
        })

        if (isJsonString(userObjectString)) {
          sessionStorage.setItem('tma:initData', initData)
        }
      }

      const tgInitData = sessionStorage.getItem('tma:initData')
      const tgHash = sessionStorage.getItem('tma:hash')

      const localAuth =
        'user=%7B%22id%22%3A101557918%2C%22first_name%22%3A%22Ali%F0%9F%92%8E%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22Alihy49%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%7D&chat_instance=6735810750783036760&chat_type=sender&auth_date=1730034230&hash=13f30081ee007350a3670524fc088e4e17092a6a9a570f468ceb184f50e455e2'
      const auth =
        RuntimeConfig.public.DEV_MODE === 'development' ? localAuth : tgInitData
      let userObj
      if (tgHash) {
        const userParam = tgHash.match(/user=([^&]+)/)?.[1]
        const decodedUser = decodeURIComponent(decodeURIComponent(userParam))
        try {
          userObj = JSON.parse(decodedUser)
        } catch (err) {
          // Sentry.captureException(err)
        }
      }

      const user = useUserStore()
      user.token = tgInitData
      const body = {
        token: auth,
        isInvited: user.friendToken ? true : false,
        joinSource: user.joinSource,
        telegramLastName: userObj ? userObj.last_name : undefined,
        telegramLanguage: userObj ? userObj.language_code : undefined,
        telegramAppVersion: userObj ? userObj.tgWebAppVersion : undefined,
        telegramPlatform: userObj ? userObj.tgWebAppPlatform : undefined,
        telegramPhotoUrl: userObj ? userObj.photo_url : undefined,
      }
      return postApi('/auth', body, false, useAuthApi)
    }
  }

  const refreshToken = async (refreshToken) => {
    const body = {
      refreshToken,
    }
    return postApi('/auth/refresh-token', body)
  }

  const setGameData = async (body) => {
    return postApi('/game/data', body)
  }

  const setScore = (body) => {
    return postApi('/game/score', body)
  }

  const buyPack = (packPublicId, toast) => {
    const body = {
      packPublicId,
    }
    return postApi('/shop/buy', body, toast)
  }

  const wheelSpin = () => {
    return postApi('/wheel/spin')
  }

  const sendTransaction = (packId) => {
    const body = {
      packId,
    }

    return postApi('payment/buy-with-tether', body, false)
  }

  const campaignBuyWithTether = (campaignId) => {
    const body = {
      campaignId,
    }
    return postApi('/payment/campaign/entry-with-tether', body)
  }

  const buyWithStar = (packId) => {
    const body = {
      packId,
    }

    return postApi('payment/buy-with-star', body)
  }

  const buyItemTether = (itemId) => {
    const body = {
      itemId,
    }

    return postApi('/payment/buy-item-tether', body)
  }

  const buyItemStar = (itemId) => {
    const body = {
      itemId,
    }
    return postApi('/payment/buy-item-star', body)
  }

  const buyItemStarPlaydeck = (itemId) => {
    const body = {
      itemId,
    }
    return postApi('/payment/buy-item-star-pd', body)
  }

  const buyWithStarPlaydeck = (packId) => {
    const body = {
      packId,
    }
    return postApi('payment/buy-with-star-pd', body)
  }

  const campaignBuyWithStar = (campaignId) => {
    const body = {
      campaignId,
    }

    return postApi('/payment/campaign/entry-with-star', body)
  }

  const setError = (transactionId, error) => {
    const body = {
      transactionId,
      error,
    }

    return postApi('/payment/error', body)
  }

  const checkTransaction = (transactionId) => {
    const body = {
      transactionId,
    }

    return postApi('/payment/check', body, false)
  }

  const postGamePowerUp = (powerUpPublicId, gameInstanceId) => {
    const body = {
      powerUpPublicId,
      gameInstanceId,
    }

    return postApi('/game/power-up', body)
  }

  const addFriend = async () => {
    const user = useUserStore()
    const body = {
      referrerTelegramId: user.friendToken,
    }
    if (user.friendToken) {
      const response = await postApi('/user/referrer', body)
      if (response) {
        return response.data.data
      }
    }
  }

  const editProfile = (username, avatarPublicId) => {
    const body = {
      username,
      avatarPublicId,
    }

    return postApi('/user/profile', body, true)
  }

  const setBlueFire = (body) => {
    return postApi('/game/blue-fire', body)
  }

  const profile = async () => {
    const response = await getApi('/user/profile')
    posthog.identify(response.user.telegramId, {
      email: response.user.telegramId,
      name: response.user.telegramFirstName,
      telegramFirstName: response.user.telegramFirstName,
      telegramId: response.user.telegramId,
      publicId: response.user.publicId,
      username: response.user.username,
    })
    return response
  }

  const requestPayout = (walletAddress, amount, toast) => {
    const body = {
      walletAddress,
      amount,
    }

    return postApi('/payment/request-payout', body, toast)
  }

  const revive = (gameInstanceId) => {
    const body = {
      gameInstanceId,
    }

    return postApi('/game/revive', body)
  }

  const readUserEventId = (userEventPublicId) => {
    const body = {
      userEventPublicId,
    }

    return postApi('/user-event/read', body)
  }

  const upgrades = (upgrade) => {
    const body = {
      upgrade,
    }

    return postApi('/game/upgrade', body)
  }

  const getGameData = async () => {
    return getApi('/game/data')
  }

  const getWheelItems = () => {
    return getApi('/wheel/items')
  }

  const getLeaderBoard = (dimension) => {
    return getApi(`/game/leaderboard?dimension=${dimension}&maxUsers=10`)
  }

  const getCampaignLeaderBoard = (isInvitees) => {
    const user = useUserStore()
    return getApi(
      `/game/leaderboard-campaign?maxUsers=100&campaignId=${user.campaignData.publicId}&isInvitees=${isInvitees}`,
    )
  }

  const getLastWeekLeaderboard = () => {
    return getApi(`/game/leaderboard/last-week?maxUsers=10`)
  }

  const getHighScore = (dimension) => {
    return getApi(`/game/high-score?dimension=${dimension}`)
  }

  const getHighScoreCampaign = (isInvitees) => {
    const user = useUserStore()
    return getApi(
      `/game/high-score-campaign?campaignId=${user.campaignData.publicId}&isInvitees=${isInvitees}`,
    )
  }

  const getGameInstance = () => {
    return getApi('/game/instance')
  }

  const createGameInstance = (powerUpId, campaignId) => {
    const body = {
      powerUpId,
      campaignId,
    }

    return postApi('/game/instance', body, false)
  }

  const getIndicators = () => {
    return getApi('/user/indicators')
  }

  const getTargetInfo = (targetId) => {
    return getApi(`/user/target-info?targetId=${targetId}`)
  }

  const getPacks = () => {
    return getApi('/shop/packs')
  }

  const getGamePowerUps = () => {
    return getApi('/game/power-ups')
  }

  const getLeaderboardPrizes = () => {
    const user = useUserStore()
    return getApi(
      `/game/leaderboard-prizes?campaignId=${user.campaignData?.publicId}`,
    )
  }

  const getSpinCost = () => {
    return getApi('/wheel/spin-costs')
  }

  const getInvitees = () => {
    return getApi('/user/invitees')
  }

  const getAvatars = () => {
    return getApi('/avatar/all-freebies')
  }

  const getPremiumAvatars = () => {
    return getApi('/shop/all-items?type=avatar')
  }

  const nextRevive = (gameInstanceId) => {
    return getApi(`/game/next-revive?gameInstanceId=${gameInstanceId}`)
  }

  const getDailyRewards = () => {
    return getApi('/daily-reward')
  }

  const getUserEventList = () => {
    return getApi('/user-event/all')
  }

  const getLeaderBoardPrizes = () => {
    return getApi('/game/leaderboard-prizes')
  }

  const getPowerUps = () => {
    return getApi('/game/power-ups')
  }

  const userUpgrades = () => {
    return getApi('/game/user-upgrades')
  }

  const getUpgrades = () => {
    return getApi('/game/upgrades')
  }

  const getTasks = () => {
    return getApi('/daily-task/all')
  }

  const getCompletedDailyTasks = () => {
    return getApi('/daily-task/daily-tasks')
  }

  const getAchievements = () => {
    return getApi('/achievement/all')
  }

  const getCompletedAchievements = () => {
    return getApi('/achievement/achievements')
  }

  const getCoinIdle = () => {
    const showToast = false
    return getApi('/user/coin-idle', showToast)
  }

  const getRequestPayouts = () => {
    return getApi('/payment/request-payouts')
  }

  const campaignActive = () => {
    return getApi('/campaign/active')
  }

  const getUserItems = () => {
    return getApi('/shop/user-items')
  }

  const userCampaign = () => {
    return getApi('/campaign/user-campaigns')
  }

  const postCoinIdleDouble = (publicId) => {
    const body = {
      publicId,
    }

    return postApi('/user/coin-idle-double', body)
  }

  const postbroadcastID = () => {
    const userStore = useUserStore()
    const bmId = userStore.broadcastMessageId
    const body = {
      broadcastMessagePublicId: bmId,
    }
    return bmId
      ? postApi('/user/broadcast', body)
      : 'Broadcast message Id not found'
  }

  return {
    auth,
    refreshToken,
    addFriend,
    profile,
    editProfile,
    revive,
    upgrades,
    readUserEventId,
    getGameData,
    getWheelItems,
    getLeaderBoard,
    getCampaignLeaderBoard,
    getLastWeekLeaderboard,
    getHighScore,
    getHighScoreCampaign,
    getGameInstance,
    getIndicators,
    getTargetInfo,
    getPacks,
    getGamePowerUps,
    campaignActive,
    setScore,
    setBlueFire,
    buyPack,
    setGameData,
    sendTransaction,
    campaignBuyWithTether,
    buyWithStar,
    buyItemTether,
    buyItemStar,
    buyItemStarPlaydeck,
    buyWithStarPlaydeck,
    campaignBuyWithStar,
    setError,
    checkTransaction,
    wheelSpin,
    postGamePowerUp,
    getLeaderboardPrizes,
    getSpinCost,
    getInvitees,
    requestPayout,
    getAvatars,
    getPremiumAvatars,
    nextRevive,
    getDailyRewards,
    getUserEventList,
    getPowerUps,
    userUpgrades,
    getUpgrades,
    getLeaderBoardPrizes,
    getTasks,
    getCompletedDailyTasks,
    getAchievements,
    getCompletedAchievements,
    postbroadcastID,
    getCoinIdle,
    getUserItems,
    postCoinIdleDouble,
    getRequestPayouts,
    createGameInstance,
    userCampaign,
  }
}
